import { BrowserRouter } from 'react-router';
import { ErrorBoundary } from '@pingo/shared';
import { AppRouter } from './router';

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
